export default {
	content: (state) => {
		return state.content;
	},
	loading: (state) => {
		return state.loading;
	},
};
